import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useAppUser } from "../../../../contexts/user-context/UserContext";
import { DashboardLibraryPages } from "../../containers/library/containers/LibraryRoutes";
import "./styles.scss";
import { DashboardPublicLibraryPages } from "../../containers/public/containers/PublicLibrary";
import { useAppContext } from "../../../../contexts/app-context/AppContext";
import { DashboardAccountsPages } from "../../containers/account/containers/Account";

interface IProps {
  title: string;
  showButton?: boolean;
  showBackButton?: boolean;
  sidebarOnly?: boolean;
  type?: "PUBLIC" | "PRIVATE";
  showProfileEdit?: boolean;
  teamId?: string;
}

const PageHeader = (props: IProps) => {
  const { id } = useParams() as any;
  const history = useHistory();
  const appUser = useAppUser();
  const app = useAppContext();

  const getTitle = (): string => {
    if (!appUser.userRole.isModerator && appUser.userRole.isMember) {
      const currentPath = window.location.pathname;

      if (props.title === "Member") {
        if (currentPath.includes(appUser.memberId)) {
          return "My progress";
        } else {
          return "Team member progress";
        }
      } else if (props.title === "Team") {
        return "Team progress";
      } else {
        return props.title;
      }
    } else {
      return props.title;
    }
  };

  return (
    <div>
      <div
        className="page-header-wrapper "
        style={{
          width: `calc(100vw - ${props.sidebarOnly ? "100px" : "400px"})`,
        }}
      >
        <div className="blue-line ">
          <div className="text-left title">
            <span className=" header-text">{getTitle()}</span>
          </div>

          <div className="text-right button">
            {(appUser.userRole.isAdmin || appUser.userRole.isModerator) &&
              props.showButton && (
                <button
                  onClick={() => {
                    if (props.type && props.type === "PUBLIC") {
                      history.push(
                        DashboardPublicLibraryPages.PUBLIC_CREATE_NEW_WORKSHOP
                      );
                    } else {
                      history.push(DashboardLibraryPages.CREATE_NEW_WORKSHOP);
                    }
                  }}
                  className="header-btn"
                >
                  Create New Workshop
                </button>
              )}
          </div>

          {props.showBackButton && app.backURLs && app.backURLs.length > 0 && (
            <div className="text-right button">
              <button
                onClick={() => {
                  history.push(app.popBackURL() || "/dashboard/account");
                }}
                className="header-btn"
              >
                Back
              </button>
              {props.showProfileEdit && (
                <button
                  onClick={() => {
                    history.push(
                      DashboardAccountsPages.ACCOUNT_COMPANY.replace(":id", id)
                    );
                  }}
                  className="header-btn ml-2"
                >
                  Edit Profile
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
